import React, { PropsWithChildren } from "react"
import styled from "styled-components"

const TextStyle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  .gradient-button {
    width: 10px;
    height: 10px;
    transform: rotate(-45deg);
    background: linear-gradient(
      ${(props) => props.theme.buttonGradientFirst},
      ${(props) => props.theme.buttonGradientSecond}
    );
  }
  @media (max-width: 1200px) {
    margin-top: 4px;
  }
  .value {
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: ${(props) => props.theme.whiteIcon};
    margin-left: 10px;
    @media (max-width: 1200px) {
      font-size: 12px;
      white-space: break-spaces;
    }
  }
`

interface IDescriptivePointsProps {
  itemArray: {
    id: number
    value: string
  }[]
}

const DescriptivePoints: ({
  itemArray,
}: PropsWithChildren<IDescriptivePointsProps>) => any = ({ itemArray }) => {
  return itemArray?.map((item, index) => (
    <TextStyle key={index}>
      <div className="gradient-button" />
      <span className="value">{item.value}</span>
    </TextStyle>
  ))
}

export { DescriptivePoints }
